module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = 72
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20